import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ trail }) {
  return (
    <nav aria-label="Breadcrumb" className="text-[0.8rem]">
      <ol className="flex flex-wrap items-center gap-1.5 text-charcoal/55">
        <li>
          <Link to="/" className="transition-colors hover:text-forest" data-testid="breadcrumb-home">
            Home
          </Link>
        </li>
        {trail.map((item, i) => (
          <li key={i} className="flex items-center gap-1.5">
            <ChevronRight className="h-3 w-3 text-clay" aria-hidden="true" />
            {item.to ? (
              <Link to={item.to} className="transition-colors hover:text-forest">
                {item.label}
              </Link>
            ) : (
              <span className="font-medium text-forest" aria-current="page">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
